// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.olkeS{width:100%}.olkeS::part(line){transition:all .2s ease-in-out}`, "",{"version":3,"sources":["webpack://./src/components/Loading/LoadMoreButton.module.scss"],"names":[],"mappings":"AACA,OACI,UAAA,CAEA,mBACI,8BAAA","sourcesContent":["@import \"/home/runner/work/commerce-studio/commerce-studio/apps/commerce-studio/src/styles/shared/utils.scss\";\n.smoothLoading {\n    width: 100%;\n    \n    &::part(line) {\n        transition: all 0.2s ease-in-out;\n      }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"smoothLoading": `olkeS`
};
export default ___CSS_LOADER_EXPORT___;
